import { render, staticRenderFns } from "./custom-tab.vue?vue&type=template&id=484a72ce&scoped=true"
import script from "./custom-tab.vue?vue&type=script&lang=js"
export * from "./custom-tab.vue?vue&type=script&lang=js"
import style0 from "./custom-tab.vue?vue&type=style&index=0&id=484a72ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a72ce",
  null
  
)

export default component.exports